/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'

import { flowElementTypes } from '../../../constants'
import { ErrorsContext } from '../../../contexts'
import { Logger, LoggerTypes } from '../../../utils'
import { Button, buttonModes, buttonTypes, FormTitle } from '../../../components'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    elementError: {
      backgroundColor: theme.palette.error.main,
      opacity: 0.5
    }
  })
)

export const HeaderErrorsDialog = ({ setOpenDialog }) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()

  const errors = useContext(ErrorsContext)

  const onCloseDialog = () => setOpenDialog(false)

  Logger.trace(LoggerTypes.CONTAINER, 'HeaderErrorsDialog.render()', { errors })

  return (
    <Dialog
      open={true}
      onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
      maxWidth="xl"
      width="xl"
      className="HeaderErrorsDialog"
    >
      <DialogContent>
        <FormTitle title={t('header.dialogs.errors.title')} style={{ fontSize: '20px' }} />
        <section>
          <ul>
            {(errors &&
              errors.map((err, index) => {
                const messages =
                  (err && err.messages && err.messages.map((msg, i) => <div key={`r-${i}`}>{msg}</div>)) || null

                const attributeName = err?.element_id.includes('Gateway_')
                  ? flowElementTypes.CONDITION
                  : err?.element_id.includes('Event_')
                  ? flowElementTypes.START
                  : err?.element_id.includes('Activity_')
                  ? flowElementTypes.TASK
                  : ''

                return (
                  messages && (
                    <li key={`m-${index}`}>
                      <b className={`${styleClasses.elementError}`}>{attributeName}</b>
                      <span>
                        {t('header.dialogs.errors.error')} {index + 1}
                      </span>
                      <ol>{messages}</ol>
                    </li>
                  )
                )
              })) ||
              t('header.dialogs.errors.not_found')}
          </ul>
        </section>
      </DialogContent>
      <DialogActions>
        <Button
          className="common_fullwidth"
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.close')}
          icon={<CloseIcon />}
          onClick={onCloseDialog}
        />
      </DialogActions>
    </Dialog>
  )
}

HeaderErrorsDialog.displayName = 'HeaderErrorsDialog'

HeaderErrorsDialog.propTypes = {
  setOpenDialog: PropTypes.func.isRequired
}

HeaderErrorsDialog.defaultProps = {
  setOpenDialog: () => {}
}
